<template>
  <div class="signin-container">
    <div class="signin-container__left">
      <img src="../../assets/img/certilogo.png" class="logo-image" />
      <div class="signin-container__left-bg" :class="bgStyleNumber">
        <!--
          입력란에 포커스가 있는 동안에는 자동 재생을 멈춘다.

          배경 전환은 장식이지만 3초마다 bgStyleNumber 를 바꾸고, 그러면 로그인 폼까지
          통째로 다시 그려진다. 그 재렌더링이 입력 중인 글자를 지웠다 — Vue 는 재렌더링마다
          input 의 value 를 무조건 되쓰는데(runtime-core #1471) 거기에는 IME 조합 중인지
          보는 가드가 없고, ant-design-vue 는 조합 중에 v-model 을 갱신하지 않으므로
          (vc-input 의 lazy 기본값이 true) 되쓰이는 값이 조합 시작 전의 옛 값이다.

          폰에서 특히 심했다. 폰 키보드는 단어 하나를 다 칠 때까지 조합을 열어 두므로
          3초 안에 조합이 끝나는 일이 거의 없다. 게다가 1200px 이하에서는 이 캐러셀이
          display:none 인데도 타이머는 계속 돌아, 보이지도 않는 애니메이션이 입력을 지웠다.

          슬라이드와 배경이 함께 멈추므로 둘이 어긋나지 않는다. autoplay 가 바뀌면
          vue3-carousel 이 resetAutoplay() 로 타이머를 다시 잡는다(포커스가 빠지면 재개).
        -->
        <carousel :autoplay="isInputFocused ? 0 : 3000" :wrap-around="true" :items-to-show="1" @slide-start="slideStartFunction">
          <slide :key="1">
            <img class="slider-image" src="../../assets/img/login/img-dentium.webp" />
          </slide>
          <slide :key="2">
            <img class="slider-image" src="../../assets/img/login/img-plasmapp.webp" />
          </slide>
          <slide :key="3">
            <img class="slider-image" src="../../assets/img/login/img-sunmedical.webp" />
          </slide>
          <slide :key="4">
            <img class="slider-image" src="../../assets/img/login/img-zeiss.webp" />
          </slide>
          <template #addons>
            <pagination />
          </template>
        </carousel>
      </div>
    </div>
    <div class="signin-container__right">
      <img src="../../assets/img/certilogo.png" class="mobile-logo-image no-mobile" />
      <div class="signin-container__right-bg" :class="bgStyleNumber">
        <div class="signin-container-wrap">
          <div class="signin-area">
            <div class="logo-wrap">
              <img src="../../assets/img/login/icon-manufacturer.webp" />
            </div>
            <div class="title-wrap">
              <h4>
                {{ $t("signin_title") }}
              </h4>
            </div>
            <a-alert v-if="geoNotice" type="warning" show-icon :message="geoNotice" description="국외 예외나 허용 IP 가 승인된 계정은 그대로 로그인할 수 있습니다." style="margin-bottom: 12px" />
            <div class="input-wrap">
              <p class="input-title">
                {{ $t("signin_id") }}
              </p>
              <a-input v-model:value="email" :placeholder="$t('signin_id_empty_err_content')" @keyup.enter="handleEnterKey" @input="handleIdValue" @focus="isInputFocused = true" @blur="isInputFocused = false">
                <template #prefix>
                  <i class="fa-regular fa-user" />
                </template>
              </a-input>
            </div>
            <div class="input-wrap">
              <p class="input-title">
                {{ $t("signin_password_placeholder") }}
              </p>
              <a-input-password :placeholder="$t('signin_pw_empty_err_content')" id="password" v-model:value="password" @keyup.enter="handleEnterKey" @focus="isInputFocused = true" @blur="isInputFocused = false">
                <template #prefix>
                  <i class="fa-regular fa-key" />
                </template>
              </a-input-password>
            </div>
            <div class="infomation-area">
              <img src="../../assets/img/login/icon-dentium.webp" class="no-mobile" />
              <span><span class="mobile-highlight">덴티움 통합 아이디</span>인 경우, 덴티움 ERP에서 아이디와 비밀번호를 확인해주세요.</span>
            </div>
            <a-button @click="signIn" type="primary">
              {{ $t("signin_login_btn") }}
            </a-button>
            <div class="inquiry-wrap">
              <a href="https://certi.life/#contact" target="_blank">
                {{ $t("signin_join_text") }}
                <span style="margin: 0 !important"> &#183; </span>
                {{ $t("signin_cooperate_text") }}
              </a>
              <span>|</span>
              <div @click="findPwd" ref="findPwd" style="cursor: pointer">
                <a>
                  {{ $t("signin_find_password") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-flow-logo no-mobile-opacity">
        <div class="footer-flow-logo__left"></div>
        <div class="flow-wrap no-mobile">
          <img src="../../assets/img/login/logo-zeiss.webp" />
          <img src="../../assets/img/login/logo-dentium.webp" />
          <img src="../../assets/img/login/logo-plasmapp.webp" />
          <img src="../../assets/img/login/logo-point.webp" />
          <img src="../../assets/img/login/logo-withwell.webp" />
          <img src="../../assets/img/login/logo-sunmedical.webp" />
          <img src="../../assets/img/login/logo-kakaoenterprise.webp" />
          <img src="../../assets/img/login/logo-groundx.webp" />
          <img src="../../assets/img/login/logo-pilab.webp" />
          <img src="../../assets/img/login/logo-dentalmax.webp" />
          <img src="../../assets/img/login/logo-zeiss.webp" />
          <img src="../../assets/img/login/logo-dentium.webp" />
          <img src="../../assets/img/login/logo-plasmapp.webp" />
          <img src="../../assets/img/login/logo-point.webp" />
          <img src="../../assets/img/login/logo-withwell.webp" />
          <img src="../../assets/img/login/logo-sunmedical.webp" />
          <img src="../../assets/img/login/logo-kakaoenterprise.webp" />
          <img src="../../assets/img/login/logo-groundx.webp" />
          <img src="../../assets/img/login/logo-pilab.webp" />
          <img src="../../assets/img/login/logo-dentalmax.webp" />
          <img src="../../assets/img/login/logo-zeiss.webp" />
          <img src="../../assets/img/login/logo-dentium.webp" />
          <img src="../../assets/img/login/logo-plasmapp.webp" />
          <img src="../../assets/img/login/logo-point.webp" />
          <img src="../../assets/img/login/logo-withwell.webp" />
          <img src="../../assets/img/login/logo-sunmedical.webp" />
          <img src="../../assets/img/login/logo-kakaoenterprise.webp" />
          <img src="../../assets/img/login/logo-groundx.webp" />
          <img src="../../assets/img/login/logo-pilab.webp" />
          <img src="../../assets/img/login/logo-dentalmax.webp" />
        </div>
        <div class="footer-flow-logo__right"></div>
      </div>
    </div>
    <otp-verify-modal ref="otp" />
    <!-- <div class="footer-wrap">
      <span>{{ $t('signin_certilife_text') }}</span>
      <span>ㆍ</span>
      <a :href="privacyPolicyUrl" target="_blank">{{ $t('signin_pp') }}</a>
      <span>ㆍ</span>
      <a :href="termsOfUseUrl" target="_blank">{{ $t('signin_tos') }}</a>
    </div> -->
  </div>
</template>
<script setup>
import { reactive } from "vue";
import { useForm } from "ant-design-vue/es/form";

const modelRef = reactive({
  name: "",
  region: undefined
});
const rulesRef = reactive({
  name: [
    {
      required: true,
      message: "Please input Activity name"
    },
    {
      min: 3,
      max: 5,
      message: "Length should be 3 to 5",
      trigger: "blur"
    }
  ]
});
const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef);
</script>
<script>
import { removeProfile } from '@/utils/tokenStore';
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

import CustomButton from "../components/CustomButton.vue";
import { oneBtnDialog } from "../../utils/utils";
import { Constants } from "../../utils/constants";
import { signInMixin } from "@/mixins/signInMixin";
import OtpVerifyModal from "@/views/components/OtpVerifyModal.vue";
import { errorCode, withRemainingAttempts } from "@/utils/mfa";

import { bridges } from "@/utils/bridges";
import { gsap } from "gsap";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "signIn",
  mixins: [signInMixin],
  components: {
    CustomButton,
    Carousel,
    Slide,
    Pagination,
    Navigation,
    OtpVerifyModal
  },
  data() {
    return {
      email: "",
      password: "",
      role: "MANUFACTURER",
      showPassword: false,
      privacyPolicyUrl: Constants.policiesUrl.privacyPolicyUrl,
      termsOfUseUrl: Constants.policiesUrl.termsOfUseUrl,
      bgStyleNumber: "bg-1",
      // 아이디·비밀번호 입력란에 포커스가 있는가 (위 carousel 주석 참고)
      isInputFocused: false,
      // 국외 접속 안내(로그인 전 geo-check 결과, signInMixin.checkGeo). 빈 문자열이면 숨김
      geoNotice: ""
    };
  },
  created() {
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-white-100");
  },
  beforeMount() {},
  beforeUnmount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-white-100");
    const pointerElement = document.querySelector(".finger-pointer");
    pointerElement.style.opacity = 0;
  },
  mounted() {
    removeProfile("locale");
    this.checkGeo();
  },
  computed: {
    isPasswordEmpty() {
      return this.password === "";
    },
    isEmailEmpty() {
      return this.email === "";
    }
  },
  methods: {
    //MARK: webToApp_TEST
    /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
    async requestWebToApp_TEST() {
      console.log("Signin.vue requestWebToApp_TEST");

      const requestWebToAppValue = { key0: "valueStringFromWeb0", key1: 1234567890, key2: true };

      window.requestWebToApp_TEST(requestWebToAppValue);
    },

    handleIdValue() {
      this.email = this.email.replace(/\s+/g, "");
    },
    /*
     * 조합(IME) 중의 Enter 는 후보 확정이지 제출이 아니다.
     *
     * ant-design-vue 는 조합 중 v-model 을 갱신하지 않으므로(vc-input 의 lazy 기본값이 true)
     * 그대로 제출하면 화면에는 글자가 보이는데 email 은 조합 시작 전의 옛 값이다. 그래서
     * 폰에서 아이디를 치고 키보드의 완료를 누르면 "ID를 입력해주세요" 가 떴다.
     *
     * 조건은 ant-design-vue 가 스스로 쓰는 것과 같은 것을 본다(e.isComposing || target.composing).
     * 조합이 끝나면 v-model 이 따라오므로, 확정한 뒤 한 번 더 누르면 정상 제출된다.
     */
    handleEnterKey(event) {
      if (event.isComposing || event.target.composing) return;
      this.signIn();
    },
    slideStartFunction(data) {
      this.bgStyleNumber = `bg-${data.slidingToIndex + 1}`;
    },
    async findPwd(event) {
      // event.preventDefault();
      await oneBtnDialog(this.$i18n.t("signin_dentium_pwcheck_title"), this.$i18n.t("signin_dentium_pwcheck_content"), false);
      const findPwdTag = this.$refs.findPwd;
      if (findPwdTag) {
        window.open("https://certi.life/#contact");
      }
    },
    async validateData() {
      let result = true;
      if (!this.email) {
        result = false;
        await oneBtnDialog(this.$i18n.t("signin_id_empty_err_title"), this.$i18n.t("signin_id_empty_err_content"), false);
      } else if (!this.password) {
        result = false;
        await oneBtnDialog(this.$i18n.t("signin_pw_empty_err_title"), this.$i18n.t("signin_pw_empty_err_content"), false);
      }
      return result;
    },

    /**
     * 로그인 처리
     * @author dongxun (2025-12-17)
     *
     * [동작 방식]
     * MANUFACTURER role만 전송해도 DENTAL_LABORATORY 계정 로그인 가능
     * - inapi에서 username만으로 계정 조회 후 RoleHierarchyService.canLoginAs()로 권한 검증
     * - DENTAL_LABORATORY는 MANUFACTURER 권한을 포함하므로 canLoginAs() 통과
     *
     * [변경 이유]
     * 기존 문제점:
     * - inapi가 username + role 조합으로 DB 조회하여 canLoginAs()가 실제로 작동하지 않았음
     * - 우회책으로 ["MANUFACTURER", "DENTAL_LABORATORY"] 두 role을 순차 시도
     * - 매 로그인마다 불필요한 401 에러 로그 발생
     *
     * 해결:
     * - inapi 수정: DB 쿼리에서 role 조건 제거, canLoginAs()로 권한 검증
     * - 이제 MANUFACTURER role 하나만 전송해도 정상 동작
     *
     * [주의] 다시 배열에 DENTAL_LABORATORY를 추가하지 않아도 됩니다.
     */
    async signIn() {
      if (!(await this.validateData())) return;

      const email = this.email.trim();
      const roles = ["MANUFACTURER"];

      const { response, lastError } = await this.performLogin(email, this.password, roles);

      if (response) {
        await this.handleLoginSuccess(response, email);
      } else {
        await this.handleLoginError(lastError);
      }
    },

    /**
     * 401 에러 처리 오버라이드 — 실패 횟수는 화면 자체 카운트 대신 서버 값
     * (연속 3번째부터 remainingAttempts, 5번째면 423 ACCOUNT_LOCKED, SPEC-SENDCERT-001 REQ-MFA-009)
     */
    async handle401Error(error) {
      console.log(error);
      await oneBtnDialog(this.$i18n.t("signin_login_err_title"), withRemainingAttempts(error.response.data.message, error), false);
    },

    // 서버가 잠그면 고객센터 안내 손가락을 띄우고 나머지는 mixin 처리
    async handleLoginError(lastError) {
      if (errorCode(lastError) === "ACCOUNT_LOCKED") showFingerPointer();
      await signInMixin.methods.handleLoginError.call(this, lastError);
    }
  }
};

function showFingerPointer() {
  console.log("bind showFingerPointer");
  let setInterval1 = setInterval(() => {
    let parentNode = document.getElementById("ch-plugin-entry");
    if (parentNode) {
      const pointerElement = document.querySelector(".finger-pointer");
      const shadowHost = document.querySelector("#ch-plugin-entry>div");
      if (!shadowHost) return;

      const shadowRoot = shadowHost.shadowRoot || shadowHost.attachShadow({ mode: "open" });

      if (shadowRoot) {
        clearInterval(setInterval1);
        let setInterval2 = setInterval(() => {
          let launcherElement = shadowRoot.querySelector('[data-ch-testid="launcher"]');

          if (!launcherElement) {
            return false;
          }

          if (window.getComputedStyle(launcherElement).display == "none") {
            return false;
          }
          clearInterval(setInterval2);
          pointerElement.style.opacity = 1;
          var playAnimation = gsap.timeline({ repeat: -1, repeatDelay: 0 });
          playAnimation.to(pointerElement, {
            bottom: 70,
            duration: 1,
            yoyo: true,
            repeat: 1,
            ease: "ease-out"
            // ease:'none',
          });
          let checkTooltipInterval = setInterval(() => {
            let isShowTooltip = shadowRoot.querySelector("article");
            if (isShowTooltip) {
              pointerElement.style.right = "280px";
              pointerElement.style.bottom = "150px";

              playAnimation.pause();
              var playAnimation2 = gsap.timeline({ repeat: -1, repeatDelay: 0 });
              playAnimation2.to(pointerElement, {
                bottom: 160,
                duration: 1,
                yoyo: true,
                repeat: 1,
                ease: "ease-out"
                // ease:'none',
              });
              clearInterval(checkTooltipInterval);
              let checkTooltipIsHideInterval = setInterval(() => {
                let isShowTooltip = shadowRoot.querySelector("article");
                if (!isShowTooltip) {
                  pointerElement.style.right = "70px";
                  pointerElement.style.bottom = "50px";

                  playAnimation2.pause();
                  playAnimation.play();
                  clearInterval(checkTooltipIsHideInterval);
                }
              }, 200);
            }
          }, 200);
          setTimeout(() => {
            clearInterval(checkTooltipInterval);
          }, 2000);
        });
      }
    }
  }, 200);
}
</script>
<style lang="scss" scoped>
@import "../../assets/scss/signin";

a.forwardLink:hover {
  color: #278aec;
}
</style>
